import IconButton from "@Components/IconButton";
import Table from "@Components/Table";
import { Column } from "@Components/Table/types";
import { formatDate, formatPrice } from "@Utils/functions";
import { AiOutlineArrowRight } from "react-icons/ai";
import { useNavigate, useSearchParams } from "react-router-dom";

// import DealersSearch from "@Components/Search/DealersSearch";
import useGetDealers from "@Hooks/useDealers";
import { Dealership } from "@Types/dealerships";
import styles from "./Dealers.module.scss";
import InformationTabs from "./InformationTabs/InformationTabs";

export const statusStyle = (background: string): React.CSSProperties => ({
  fontWeight: 700,
  fontSize: 18,
  background,
  padding: "5px 0px",
  borderRadius: "5px",
  justifyContent: "center",
  width: "100%",
  color: "#FFF",
  maxWidth: "250px",
  whiteSpace: "pre-wrap",
  textAlign: "center",
});

const Dealers = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const columns: Column<Dealership>[] = [
    {
      id: "name",
      label: "Name",

      value: (dealer) => dealer?.data?.info?.displayName || "N/A",
    },
    {
      id: "loansCount",
      label: "Loans Count",
      value: (dealer) => dealer?.dealCount?.toString() || "0",
    },
    {
      id: "amountFinanced",
      label: "Amount Financed",
      value: (dealer) => formatPrice(dealer?.totalAmountFinanced ?? 0) ?? "0",
    },
    {
      id: "state",
      label: "State",
      value: (dealer) => dealer.data?.info?.state || "N/A",
    },
    {
      id: "latestDealDate",
      label: "Latest Deal Date",
      value: (dealer) =>
        dealer?.latestFundedAt
          ? formatDate(new Date(dealer?.latestFundedAt), "medium")
          : "N/A",
    },
    {
      id: "firstDealDate",
      label: "First Deal Date",
      value: (dealer) =>
        dealer?.firstFundedAt
          ? formatDate(new Date(dealer?.firstFundedAt), "medium")
          : "N/A",
    },
    {
      id: "actions",
      label: "Actions",
      value: (deal) => (
        <IconButton
          id={`open-dealer-${deal?._id}`}
          className={"blueCircle"}
          onClick={() => {
            navigate(`/dealers/${deal._id}?page=${currentPage}`);
          }}
        >
          <AiOutlineArrowRight size={18} />
        </IconButton>
      ),
    },
  ];
  return (
    <div className={styles.tableContainer}>
      {/* <div className={styles.search}>
        <DealersSearch />
      </div> */}

      <h2 className={styles.title}>Dealers</h2>
      <InformationTabs />
      <Table<Dealership>
        columns={columns}
        useGetFunction={useGetDealers}
        entityType="dealers"
      />
    </div>
  );
};

export default Dealers;
